import React, { Component } from 'react';
import styled from 'styled-components';

import { Font, FontWeight } from '../../../../../utils/fonts';
import mediaWidth from '../../../../../utils/mediaWidth/mediaWidth';

import AnimateCircle from '../../../../../common/AnimateCircle';
import MenuLinks from './MenuLinks';
// import form from '../../../../PopupForm';

function getCircleRadius() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    return width * 2 + height * 2;
}

class MobileMenuContent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            radius: getCircleRadius(),
            isClosed: false,
        };
        this.closeMenu = this.closeMenu.bind(this);
        this.onAnimationEnd = this.onAnimationEnd.bind(this);
        this.scrollTo = this.scrollTo.bind(this);
    }

    onAnimationEnd(toForm) {
        const { isClosed } = this.state;
        const { handleClosePopUp } = this.props;
        if (isClosed === true) {
            if (toForm === 'scroll') {
                const { scrollToForm } = this.props;
                scrollToForm();
                handleClosePopUp();
            } else {
                handleClosePopUp('toTop');
            }
        }
    }

    scrollTo() {
        this.setState({ isClosed: true }, () => {
            this.onAnimationEnd('scroll');
        });
    }

    closeMenu() {
        this.setState({ isClosed: true });
        this.onAnimationEnd();
    }

    render() {
        const {
            className,
            left = '0',
            top = '0',
            onClick,
        } = this.props;
        const { radius, isClosed } = this.state;
        return (
            <Root className={className}>
                <AnimateCircleStyled
                    radius={radius}
                    isClosed={isClosed}
                    left={left}
                    top={top}
                    onAnimationEnd={this.onAnimationEnd}
                />
                <MenuLinksStyled
                    isClosed={isClosed}
                    onClose={this.closeMenu}
                    openForm={onClick}
                    // scrollTo={this.scrollTo}
                />
            </Root>
        );
    }
}

const Root = styled.div`
    ${Font.HEADLINE};
    ${FontWeight.REGULAR};

    padding: 16px 0px 68px 0px;

    ${mediaWidth.m} {
        padding: 34px 0px 152px 0px;
    }
`;

const AnimateCircleStyled = styled(AnimateCircle)`
    width: 4px;
    height: 4px;

    top: ${({ top }) => top}px;
    left: ${({ left }) => left}px;
`;

const MenuLinksStyled = styled(MenuLinks)`
    margin-top: 179px;
`;

export default MobileMenuContent;

// onAnimationEnd() {
//     const { isClosed } = this.state;
//     if (isClosed === true) {
//         const { handleClosePopUp } = this.props;
//         handleClosePopUp();
//     }
// }

// openForm() {
//     const { handleOpenPopUp } = this.props;
//     handleOpenPopUp(form);
// }

// closeMenu(toForm) {
//     this.setState({ isClosed: true });
//     if (toForm === 'toForm') {
//         this.openForm();
//     } else {
//         this.onAnimationEnd();
//     }
// }
